import { iconeUi } from '../../assets/ui';

interface Props {
  nome: string;
  tam?: number;
}

/** Pinta com `currentColor` — o SVG como `<img>` caía no preto. */
export function Icone({ nome, tam = 22 }: Props) {
  return (
    <span
      className="kit-icone"
      style={{
        width: tam,
        height: tam,
        ['--kit-icone-src' as string]: `url("${iconeUi(nome)}")`
      }}
      aria-hidden="true"
    />
  );
}
